export const ResourceUtils = {

  addTypeToDocuments: (documents) => {
    const modifiedResponse = documents.map(item => {
      let fileType;
      let fileExtension = item.url?.split('.').pop();

      if (!item.isURL && fileExtension == '')
        fileType = 'Document';
      else if (item.isURL && !(item.url.toLowerCase().includes('/imagelibrary/')))
        fileType = 'Link';
      else if (fileExtension == 'mp3')
        fileType = 'Audio';
      else if (fileExtension == 'mp4')
        fileType = 'Video';
      else if (fileExtension == 'pdf')
        fileType = 'PDF';
      else if (fileExtension == 'doc' || fileExtension == 'docx')
        fileType = 'MS Word';
      else if (fileExtension == 'ppt' || fileExtension == 'pptx')
        fileType = 'Power Point';
      else
        fileType = 'Other';

      return {
        ...item,
        type: fileType
      };
    });
    return modifiedResponse;
  },

  customSort: (resourceData, property, sortAsc) => {
    let sortedData = [...resourceData];
    if (typeof sortedData[0][property] === 'string') {
      return sortedData.sort((a, b) => ResourceUtils.sortByString(a[property], b[property], sortAsc));
    } else {
      return sortedData.sort((a, b) => ResourceUtils.sortByNumber(a[property], b[property], sortAsc));
    }
  },

  sortByString: (a, b, sortAsc) => {
    const valueA = a.toLowerCase();
    const valueB = b.toLowerCase();
    return sortAsc ? valueA.localeCompare(valueB) : valueB.localeCompare(valueA);
  },
  
  sortByNumber: (a, b, sortAsc) => {
    const valueA = parseInt(a);
    const valueB = parseInt(b);
    return sortAsc ? valueA - valueB : valueB - valueA;
  }
};